import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private appService: AppService,
  ) {}

  protected readonly multiplyNum = 3;
  protected readonly siteSizeWidth = `${116 * this.multiplyNum}`;
  protected readonly siteSizeH5Width = `${116 * this.multiplyNum}`;
  protected readonly logoHeight = `${24 * this.multiplyNum}`;

  ngOnInit() {
    // campaign image redirectUrl 如果無效，導過來會帶campaignRedirectFallback，如果有就會自動導回首頁
    const hasFallBackParam = this.route.snapshot.queryParamMap.get('campaignRedirectFallback') === 'home';
    if (hasFallBackParam) {
      this.router.navigateByUrl(`/${this.appService.languageCode}`, { replaceUrl: true });
    }
  }

  goHome() {
    this.router.navigate(['']);
  }
}
